export const ROLES = {
    SUPERADMIN: 1,
    DEVELOPER: 5,
    ADMIN: 10,
    COURSE_DESIGNER: 20,
    OPERATORE: 30,
    SUPERPARTNER:35,
    PARTNER: 40,
    DOCENTE: 50,
    TUTOR: 60,
    CORSISTA: 70,
    ISPETTORE: 80,
    CONSULENTE_SICUREZZA: 85
    // NB modello GAS (Gestione Adempimenti Sicurezza) a 2 livelli:
    //  - l'AGENZIA gestisce la PROPRIA compliance interna (i suoi dipendenti),
    //    non clienti terzi. Per questo NON esiste un ruolo "azienda cliente".
    //  - il "lavoratore" è solo un'anagrafica (safety_lavoratori), non un
    //    ruolo di accesso: se deve fare un corso HE diventa CORSISTA (70) e
    //    si collega via safety_lavoratori.id_utente.
    //  - CONSULENTE_SICUREZZA (85) = consulente esterno che affianca l'agenzia.
}
